import { Box, Typography } from "@mui/material";

const RiskProfileBar = ({
  highPoints = 0,
  lowPoints = 0,
  pointAchieved = 0,
}: {
  highPoints: number;
  lowPoints: number;
  pointAchieved: number;
}) => {
  const clientPoint =
    ((pointAchieved - lowPoints) / (+highPoints - lowPoints)) * 100;
  return (
    <Box
      width={"100%"}
      display={"flex"}
      gap={1}
      alignItems={"center"}
      position={"relative"}
    >
      <Typography fontSize={12} color="var(--grey-700)" fontWeight={600}>
        {lowPoints}
      </Typography>
      <Box
        sx={{
          width: "100%",
          background: `linear-gradient(90deg, #E62C15 0%, #DC9E52 30%,#E3BC56 60%, #15803D 100%)`,
          height: 18,
          borderRadius: "32px",
          "::before": {
            content: `" "`,
            position: "absolute",
            height: "100%",
            width: "3px",
            background: "#ffffff",
            top: 0,
            left: `${clientPoint}%`,
            borderRadius: "32px",
          },
          "::after": {
            content: `"${pointAchieved}"`,
            background: "#ffffff",
            position: "absolute",
            left: `${clientPoint - 1.5}%`,
            top: -25,
            fontSize: 12,
            fontWeight: 600,
            border: "solid 1px #9AA4B2",
            borderRadius: "100%",
            height: 20,
            width: 20,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
        }}
      />
      <Typography fontSize={12} color="var(--grey-700)" fontWeight={600}>
        {highPoints}
      </Typography>
    </Box>
  );
};

export default RiskProfileBar;
